<template>
  <router-view/>
</template>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>
